import React, {FC} from 'react';
import './style.scss';
import Header from "../../Header";
import goBack from "../../../assets/img/header/go__back.svg";
import shareMixIcon from "../../../assets/img/header/share__mix.svg";
import favoriteMixActive from "../../../assets/img/header/favorite__mix--active.svg";
import favoriteMix from "../../../assets/img/header/favorite__mix.svg";
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {handlerFavoriteMix} from "../../../modules/Favorite";
import {shareMix} from "../../../services/api/vkApi";
import {IMix} from "../../../constants/types";

interface IMixPageHeader {
    mix: IMix,
    goToUrl?: string
}

const MixPageHeader: FC<IMixPageHeader> = ({mix, goToUrl }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    let favoriteMixes = useSelector<any, any>(state => state.favorite.favoriteMixes);
    let isActiveMix = !!favoriteMixes.find((item: any) => item.id === mix.id);

    const favoriteHandler = (infoTobacco: IMix) => {
        dispatch(handlerFavoriteMix(infoTobacco))
    };

    return (
        <Header>
            <div className="mix-week-page__header">
                <img
                    onClick={() => goToUrl ? history.push(goToUrl) : history.goBack()}
                    className="mix-week-page__back"
                    src={goBack}
                    alt="Go Back"
                />
                <div className="mix-week-page__header-center">
                    <img
                        className="mix-week-page__share"
                        onClick={() =>  shareMix(mix.id)}
                        src={shareMixIcon}
                        alt="share Mix"
                    />
                    <img
                        onClick={() => favoriteHandler(mix)}
                        className="mix-week-page__favorite"
                        src={
                            isActiveMix
                                ? favoriteMixActive
                                : favoriteMix
                        }
                        alt="Favorite Mix"
                    />
                </div>
            </div>
        </Header>
    )
};

export default MixPageHeader;
